import { useMutation } from '@apollo/client'
import { observer } from 'mobx-react'
import React, { useEffect, useState } from 'react'
import { MyModal } from '~/components/ui/MyModal'
import dayjs from 'dayjs'
import {
  CLICK_CURRENT_ADV_DIALOG,
  GET_CURRENT_ADV_DIALOG,
} from '~/graphqls/gqls'
import {
  Frequency,
  clickCurrentAdvDialog,
  clickCurrentAdvDialogVariables,
  getCurrentAdvDialog,
  getCurrentAdvDialog_marketingModule_currentPopup,
} from '~/graphqls/types'
import { useImperativeQuery } from '~/hooks/useImperativeQuery'
import styles from './AdvDialogModal.module.css'
import { MyImage } from '~/components/ui/MyImage'
import { useAuth } from '~/hooks/useAuth'
import Cookies from 'js-cookie'
import { preLoadImgs, to400Image } from '~/utils'

/** 弹窗本地key */
const FREQUENCY_COOKIE_KEY = 'home_dialog_frequency'
/** 广告弹窗 */
export const AdvDialogModal: React.FC = observer(() => {
  const { isLogin } = useAuth()
  const [visible, setVisible] = useState(false)
  const [diaLogLink, setDiaLogLink] = useState('')
  const [currentAdv, setCurrentAdv] =
    useState<getCurrentAdvDialog_marketingModule_currentPopup>()

  const getAdvAction = useImperativeQuery<getCurrentAdvDialog>(
    GET_CURRENT_ADV_DIALOG
  )
  const [clickAdvAction] = useMutation<
    clickCurrentAdvDialog,
    clickCurrentAdvDialogVariables
  >(CLICK_CURRENT_ADV_DIALOG)
  const handleOpenDialog = () => {
    setTimeout(() => {
      setVisible(true)
    }, 1000)
  }

  /** 获取弹窗信息 */
  const getData = async () => {
    try {
      const res = await getAdvAction()
      const currentPopup = res.data.marketingModule?.currentPopup

      if (!currentPopup || !currentPopup?.image) return

      setCurrentAdv(currentPopup)
      const localDialogStatus = Cookies.get(FREQUENCY_COOKIE_KEY)
      // 预加载图片
      preLoadImgs([to400Image(currentPopup?.image)])

      // 已登录情况下，频率由服务端控制
      if (isLogin) {
        handleOpenDialog()
        return
      }

      // 未登录情况下，频率由前端控制
      if (currentPopup.frequency === Frequency.DAILY_FIRST_TIME) {
        // 每日首次打开，cookies到0点前失效
        if (!localDialogStatus) {
          Cookies.set(FREQUENCY_COOKIE_KEY, currentPopup.endTime, {
            expires: dayjs().endOf('day').toDate(),
          })
          handleOpenDialog()
        }
        return
      }
      if (currentPopup.frequency === Frequency.FIRST_TIME) {
        // 首次打开，cookies到结束时间失效
        if (!localDialogStatus) {
          Cookies.set(FREQUENCY_COOKIE_KEY, currentPopup.endTime, {
            expires: dayjs(currentPopup.endTime * 1000).toDate(),
          })
          handleOpenDialog()
        }
        return
      }
    } catch (error) {}
  }
  /** 点击弹窗 */
  const clickAdv = async (id: number) => {
    if (!id) return
    try {
      await clickAdvAction({
        variables: {
          id,
        },
      })
    } catch (error) {}
  }

  useEffect(() => {
    getData()
  }, [])

  return (
    <MyModal
      open={visible}
      title={null}
      onCancel={() => setVisible(false)}
      maskStyle={{
        backgroundColor: 'rgba(0,0,0,0.8)',
      }}
      dark={true}
      width={256}
      footer={null}
      centered
      maskClosable={false}
      className={styles.customModal}
      afterClose={() => {
        diaLogLink && window.open(diaLogLink)
      }}
    >
      <div className="relative overflow-hidden  h-[341px]">
        <MyImage
          tag="v400"
          src={currentAdv?.image}
          dark
          onClick={() => {
            setVisible(false)
            currentAdv?.webLink && setDiaLogLink(currentAdv?.webLink)
            clickAdv(currentAdv?.id)
          }}
          className="w-full h-full "
        />
      </div>
    </MyModal>
  )
})
